import React, { useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { Link, Redirect, useLocation } from "react-router-dom";
import {
  useGoogleReCaptcha
} from 'react-google-recaptcha-v3';
import Loader from "../../shared/loader";
import AnonymousPage from "../anonymous-pages/anonymous-page";
import BoxWraper from "../box-wrapper";
import {
  register,
  getCountries,
  getLanguages,
  getCurrencies,
  clearRedirect,
  clearForm,
  clearRegistered
} from "./ducks/actions";
import Form from "./form";

import getConfig from "../../app/config";
import invitations from "../../shared/invitations";

function Register(props) {
  const {
    register,
    getCountries,
    countries,
    defaultCountryId,
    getLanguages,
    languages,
    defaultLanguageId,
    getCurrencies,
    currencies,
    loadingRegister,
    loadingLanguages,
    loadingCountries,
    loadingCurrencies,
    errors,
    user,
    clearForm,
    registered,
    clearRegistered,
    registering
  } = props;

  const { beta: isBeta } = getConfig() as any;

  //const pricingPlan = props.match.params.pricingPlan ? +props.match.params.pricingPlan : 0;
  const location = useLocation();
  const referral = new URLSearchParams(location.search).get('ref');
  const referralCode = new URLSearchParams(location.search).get('referral');
  const pricingPlanString = new URLSearchParams(location.search).get('pricingPlan');
  const pricingPlan = pricingPlanString ? +pricingPlanString : 0;

  useEffect(() => {
    clearForm();
    getCountries();
    getLanguages();
    getCurrencies();
  }, []);

  const { executeRecaptcha } = useGoogleReCaptcha();

  // Create an event handler so you can call the verification on button click event or form submit
  const handleReCaptchaVerify = useCallback(async (user) => {
    if (!executeRecaptcha) {
      console.log('Execute recaptcha not yet available');
      return;
    }

    const token = await executeRecaptcha('register');

    await onRegister(user, token);

  }, [executeRecaptcha]);

  if (registered) {
    clearRegistered();
    return <Redirect to={`/confirmation/${pricingPlan}`} />;
  }

  const onRegister = async (user, reCaptchaToken) => {
    const userWithPricingPlan = { ...user, pricingPlan, referralCode, reCaptchaToken };
    if (referral) {
      userWithPricingPlan.referrer = referral;
    }

    register(userWithPricingPlan);
  }

  return (
    <AnonymousPage>
      <BoxWraper width={5}>
        {(loadingRegister || loadingLanguages || loadingCountries || loadingCurrencies) && <Loader />}
        {!(loadingRegister || loadingLanguages || loadingCountries || loadingCurrencies) && <>
          {!registered && <Form
            errors={errors}
            loading={false}
            initialValues={user}
            onSubmit={handleReCaptchaVerify}
            countries={countries}
            defaultCountryId={defaultCountryId}
            languages={languages}
            defaultLanguageId={defaultLanguageId}
            currencies={currencies}
            showReferrer={referralCode == null && referral == null}
            registering={registering}
            {...props}
          />}
          {registered && <div>
            <p> Please check your email and click the confirmation link to verify your address. </p>
            <p> Once verified, log in and select your payment plan to enjoy all of Filmanize's features. </p>
            {isBeta && (
              <p>
                During the beta phase, your account will need to be approved by one of the Filmanize team before use. We'll send you an email once your account has been approved, and then you'll be ready to go!
              </p>
            )}
            <p><Link to={'./login'}>Login</Link></p>
          </div>}
        </>}
      </BoxWraper>
    </AnonymousPage>
  );
}

function mapStateToProps(state) {
  const { accountState, commonState } = state;
  return {
    countries: accountState.registerState.countries,
    defaultCountryId: accountState.registerState.defaultCountryId,
    languages: accountState.registerState.languages,
    defaultLanguageId: accountState.registerState.defaultLanguageId,
    currencies: accountState.registerState.currencies,
    user: accountState.registerState.user,
    errors: accountState.registerState.errors,
    loadingRegister: accountState.registerState.loadingRegister,
    loadingLanguages: accountState.registerState.loadingLanguages,
    loadingCountries: accountState.registerState.loadingCountries,
    loadingCurrencies: accountState.registerState.loadingCurrencies,
    redirect: accountState.registerState.redirect,
    registered: accountState.registerState.registered,
    registering: accountState.registerState.registering,
    //referralCode: accountState.registerState.referralCode,
    //referral: accountState.registerState.ref
  };
}

export default connect(mapStateToProps, {
  clearForm,
  register,
  getCountries,
  getLanguages,
  getCurrencies,
  clearRedirect,
  clearRegistered
})(Register);
